import { useMemo } from 'react';
import DiscountVoucherSnapshot from '@/components/Approval/@components/DiscountVoucher';
import { parseDiscountVoucherAttributes } from '@/utils/approval/discountVoucher';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 68 할인권 발행 — 저장 표 HTML 그대로(레거시 문서 포함). EAI 재조회 안 함 */
const DiscountVoucherSlot = ({ data }: ContentExtraProps) => {
  const voucher = useMemo(
    () => parseDiscountVoucherAttributes(data.attributes),
    [data.attributes],
  );
  if (!voucher?.voucherIssueHtml) return null;
  return (
    <ContentSlotRoot>
      <DiscountVoucherSnapshot
        voucherIssueHtml={voucher.voucherIssueHtml}
        discountItemDetailsHtml={voucher.discountItemDetailsHtml}
      />
    </ContentSlotRoot>
  );
};

export default DiscountVoucherSlot;
